import React, { useEffect, useState } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import ErrorMessage from "./ErrorMessage/ErrorMessage";
import CustomToolbar from "./CustomToolbar/CustomToolbar";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { RenderPage } from "./CustomPageLayer/CustomPageLayer";
import { useNavigate, useParams } from "react-router-dom";
import LoadingBox from "../../components/LoadingBox/LoadingBox";
import ApiURLs from "../../config/ApiURLs";
import axios from "axios";

export default function PdfVisorScreen() {
  const { filename } = useParams(); // viene de /visor/:filename
  const [pdfBlob, setPdfBlob] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [defaultTabs[0]],
    renderToolbar: (Toolbar) => CustomToolbar(Toolbar, false),
    toolbarPlugin: {
      zoomPlugin: { enableShortcuts: false },
    },
  });

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        const res = await axios.get(`${ApiURLs.baseURL}/visor/${filename}`, {
          responseType: "blob",
          headers: {
            "X-Viewer-Client": "ReactVisor",
          },
        });
        const objectUrl = URL.createObjectURL(res.data);
        setPdfBlob(objectUrl);
        window.scrollTo({ top: 0, behavior: "auto" });
      } catch (err) {
        if (err.response?.status === 401) {
          const blob = err.response.data;
          const text = await blob.text(); // lo convertimos a string
          const json = JSON.parse(text);
          const { loginUrl } = json;
          if (loginUrl) {
            window.location.href = loginUrl;
          } else {
            console.error("Error cargando PDF: No URL login sended");
          }
        } else {
          console.error("Error cargando PDF:", err);
        }
      } finally {
        setLoaded(true);
      }
    };
    fetchPdf();
  }, [filename]);

  return (
    <section className="container">
      <div className="row mt-lg-3">
        <div className="col-12 col-md-2">
          <div
            onClick={() => navigate(-1)}
            className="btn btn-outline-secondary col-12"
          >
            <span>
              <i className="fas fa-arrow-left"></i> Atrás
            </span>
          </div>
        </div>
        <div className="col">
          {!pdfBlob && !loaded && <LoadingBox />}
          {!pdfBlob && loaded && (
            <div className="alert alert-dark" role="alert">
              No ha sido posible recuperar el documento.
            </div>
          )}
          {pdfBlob && loaded && (
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.js">
              <div style={{ width: "100%", height: "720px" }} className="mb-3">
                <Viewer
                  fileUrl={pdfBlob}
                  plugins={[defaultLayoutPluginInstance]}
                  renderError={ErrorMessage}
                  defaultScale={1}
                  renderPage={RenderPage}
                />
              </div>
            </Worker>
          )}
        </div>
        <div className="col-12 col-md-2"></div>
      </div>
    </section>
  );
}
